<template>
<div>

<template v-if="thenonconformities.length">
<h2 class="text-purple-500 mt-4 mb-6">{{$store.state.languages.lang_phrases.uygunsuzluklar_var}}</h2>


<ContentTable :data="thenonconformities" :columns="columns" routename="SupplierFlowNonconformity"   identifier_row="id" identifier_row_name="nonconformity_id"></ContentTable>

</template>


</div>
</template>

<script>
export default {

  name: 'SupplierProjectFlowSummaryForVerification',
  props:["flowsupplier","nonconformities","nonconformity_types"],
   data () {
    return {
      thenonconformities:[],
      columns:[  
      {
        type:"text",
        field:"inputfield_name", 
        multilingual:true,
        header:"soru",      
        with_route:true,
        hide_on_mobile:false,
      }, 
      {
        type:"pill",
        field:"status", 
        header:"durum",       
        options:[
          {
            name:"pending",
            color:"#a855f7",
            text:"degerlendirmede",
          },
          {
            name:"rejected",
            color:"#dd4b39",
            text:"reddedildi",
          },
          {
            name:"approved",
            color:"#4dc247",
            text:"tamamlandi",
          },
          {
            name:"open",
            color:"#ff6600",
            text:"beklemede",
          },
        ],
      },
      ]
    }
  },
  mounted()
  {
    if(this.nonconformity_types.length)
    {
      
      let obj = {
        type:"text",
        field:"nonconformity_type_name", 
        header:"uygunsuzluk_tipi", 
      }     
      this.columns.push(obj) 

    }
    if(this.nonconformities.length)
    {
      for(let nonconformity of this.nonconformities)
      {
        nonconformity = this.prepareNonconformity(nonconformity) 
        this.thenonconformities.push(nonconformity)
      }
    }
    console.log(this.thenonconformities)

  },
  computed:{
    
  },
  methods:{
    prepareNonconformity(nonconformity)
    {
      console.log("prepareNonconformity")
      console.log(nonconformity)
      let obj = nonconformity.inputfield
      obj.completion = true
      obj.show_evidence_btn = false
      obj.show_info_textarea = false
      obj.read_only_state = true
      
      nonconformity.inputfield = obj
      if(nonconformity.inputfield.translations.length)
      {
        nonconformity.inputfield_name = nonconformity.inputfield.translations
        this.columns[0].multilingual = true
      }
      else
      {
        nonconformity.inputfield_name = nonconformity.inputfield.name
        this.columns[0].multilingual = false
      }
      
      if(nonconformity.lastclosurerequest)
      {
        if(nonconformity.lastclosurerequest.status=="pending")
        {
          nonconformity.status = "pending"
        }
        if(nonconformity.lastclosurerequest.status=="rejected")
        {
          nonconformity.status = "rejected"
        }

        if(nonconformity.lastclosurerequest.status=="approved")
        {
          nonconformity.status = "approved"
        }
      }
      let type = this.nonconformity_types.find((item)=>{return item.id == nonconformity.nonconformitytype_id})
      
      if(type)
      {
        if(type.translations.length)
        {
          nonconformity.nonconformity_type_name = type.translations
          this.columns[2].multilingual = true
        }
        else
        {
          nonconformity.nonconformity_type_name = type.name
          this.columns[2].multilingual = false
        }
        
      }
      else
      {
        nonconformity.nonconformity_type_name = "dfdfdf"
      }

      return nonconformity
    },
    nonconformityDataUpdated(data)
    {
      let ind = this.thenonconformities.findIndex((item)=>{return item.id == data.id})      
      this.thenonconformities[ind] = this.prepareNonconformity(data)
    }
  }
}
</script>

<style lang="css" scoped>
</style>